import { render, staticRenderFns } from "./airlines.vue?vue&type=template&id=b37dc198&scoped=true&"
import script from "./airlines.vue?vue&type=script&lang=js&"
export * from "./airlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37dc198",
  null
  
)

export default component.exports